module.exports = {
      id: "trash-usage",
      viewBox: "0 0 19.6 21.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#trash-usage",
      toString: function () {
        return this.url;
      }
    }